

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ExpiredFiPanelFactory', [function () {

    var disallowedContentMap = {
        'INSTRUMENT_VERIFICATION_FAILED': 'wallet.disallowedDueToPreAuth',
        'unsupportedGeneric': 'wallet.unsupportedDueToRisk',
        'unsupportedByProduct': 'wallet.unsupportedDueToReceiverPreference',
        'unsupportedDueToExpiration': 'wallet.unsupportedDueToExpiration'
    };
    var disallowedExp = {
        resourceName: 'xo_preauth_disallowed_instruments',
        control: 'xo_preauth_disallowed_instruments_control',
        disallowedFi: 'xo_preauth_disallowed_instruments_disallowed_fi',
        preAuth: 'xo_preauth_disallowed_instruments_preauth'
    };

    var getPxpResult = function getPxpResult(models) {
        var schedule = models.cart && models.cart.isBilling() ? 'BILLING' : 'ONE_TIME_PAYMENT';
        var approval_type = models.cart && models.cart.isPurchase() ? 'PURCHASE' : 'NOT_PURCHASE';
        var solution = _squid.$integration.isFlow('WPS') ? 'WEBSITE_PAYMENTS_STANDARD' : 'EXPRESS_CHECKOUT';

        return (0, _squid.$elmo)(disallowedExp.resourceName, { 'ctx.country': _squid.$locale.country, 'ctx.flow': 'HERMES', 'ctx.schedule': schedule, 'ctx.approval_type': approval_type, 'ctx.solution': solution }, disallowedExp.resourceName + '(.*)').then(function (result) {
            return result && result.treatment_name;
        });
    };

    var filterInstrumentsFromDisallowed = function filterInstrumentsFromDisallowed(instrument, fundingOptions) {
        var match = fundingOptions.find(function (fundingInstrument) {
            return fundingInstrument.id === instrument.id;
        });
        return match === undefined;
    };

    var disallowedDueToPreAuth = function disallowedDueToPreAuth(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.declineReason === 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var disallowedDueToOther = function disallowedDueToOther(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.type && i.type !== 'REWARDS' && i.declineReason !== 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var mapDisallowedContent = function mapDisallowedContent(disallowed, token) {
        if (disallowed.type === 'CARD') {
            disallowed.message = disallowedContentMap[disallowed.declineReason] ? disallowedContentMap[disallowed.declineReason] : disallowedContentMap['unsupportedGeneric'];
            logInstrumentToFpti(disallowed, token);
            return disallowed;
        } else {
            disallowed.message = disallowedContentMap['unsupportedGeneric'];
            logInstrumentToFpti(disallowed, token);
            return disallowed;
        }
    };

    var logInstrumentToFpti = function logInstrumentToFpti(instrument, token) {
        var fptiPayload = {
            'from': 'POST_PLANNING',
            'to': 'exception_disallowed_fi',
            'context_type': _squid.$integration.isFlow('WPS') ? 'WEBSITE_PAYMENTS_STANDARD' : 'EXPRESS_CHECKOUT',
            'context_id': token,
            'fi_id': instrument.id,
            'disallowed_reason': instrument.declineReason,
            'message': instrument.message
        };
        _logger.$logger.info('checkout_fpti', fptiPayload);
    };

    var getAllInstruments = function getAllInstruments(models) {
        var instruments = [].concat(models.checkoutSession.get('fundingOptions').getDisplayInstruments());
        var token = models.checkoutSession.get('id');

        return getPxpResult(models).then(function (result) {
            if (result === disallowedExp.control) {
                return _squid.$promise.resolve(instruments);
            } else if (result === disallowedExp.disallowedFi || result === disallowedExp.preAuth) {
                var disallowedFi = models.checkoutSession.getDisallowedInstruments();

                if (!disallowedFi) {
                    return _squid.$promise.resolve(instruments);
                }
                var fundingOption = models.checkoutSession.get('fundingOptions.instruments');
                var disallowedPreAuth = disallowedDueToPreAuth(disallowedFi, fundingOption);
                var disallowedPreferred = models.checkoutSession.getDisallowedPreferred();
                var disallowedOther = disallowedDueToOther(disallowedFi, fundingOption);

                if (disallowedPreferred) {
                    instruments.push(mapDisallowedContent(disallowedPreferred, token));
                }
                if (disallowedPreAuth && disallowedPreAuth.length) {
                    _squid.$util.forEach(disallowedPreAuth, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument, token));
                    });
                }
                if (disallowedOther && disallowedOther.length) {
                    _squid.$util.forEach(disallowedOther, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument, token));
                    });
                }
            }
            return _squid.$promise.resolve(instruments);
        });
    };

    return {
        getPxpResult: getPxpResult,
        getAllInstruments: getAllInstruments,
        disallowedExp: disallowedExp
    };
}]);

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$elmo;

_squid.$integration;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/expired-fi-panel/factory.js
// module id = ../node_modules/xo-ui-components/src/expired-fi-panel/factory.js
// module chunks = 0